import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { getFlowKey } from '../../routing/getFlowKey';
export const getPrivacyPolicyLabel = () => {
  const flowSpecificLabel = `legal.gdpr-text-${getFlowKey()}`;
  const flowSpecificLabelExists = isValidI18nKey(flowSpecificLabel);
  return flowSpecificLabelExists ? flowSpecificLabel : 'legal.gdpr-text';
};